/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * DTO для отправки данных о группе в UI
 * @export
 * @interface GroupReadDto
 */
export interface GroupReadDto {
    /**
     * ID группы
     * @type {string}
     * @memberof GroupReadDto
     */
    id?: string | null;
    /**
     * ID Клиента, для которого создана группа
     * @type {string}
     * @memberof GroupReadDto
     */
    clientId: string;
    /**
     * Описание клиента, для которого создана группа
     * @type {string}
     * @memberof GroupReadDto
     */
    clientName?: string | null;
    /**
     * Имя группы
     * @type {string}
     * @memberof GroupReadDto
     */
    name?: string | null;
    /**
     * Описание группы
     * @type {string}
     * @memberof GroupReadDto
     */
    description?: string | null;
    /**
     * Дата создания группы
     * @type {Date}
     * @memberof GroupReadDto
     */
    createdDate?: Date;
}

/**
 * Check if a given object implements the GroupReadDto interface.
 */
export function instanceOfGroupReadDto(value: object): value is GroupReadDto {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    return true;
}

export function GroupReadDtoFromJSON(json: any): GroupReadDto {
    return GroupReadDtoFromJSONTyped(json, false);
}

export function GroupReadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupReadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'clientId': json['clientId'],
        'clientName': json['clientName'] == null ? undefined : json['clientName'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
    };
}

export function GroupReadDtoToJSON(json: any): GroupReadDto {
    return GroupReadDtoToJSONTyped(json, false);
}

export function GroupReadDtoToJSONTyped(value?: GroupReadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'clientId': value['clientId'],
        'clientName': value['clientName'],
        'name': value['name'],
        'description': value['description'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
    };
}

